import { type SapAdapterConfig } from '@backend-types/AppRouter';
import { z } from 'zod';

export const backendConfigJsonSchema = z.strictObject({
  AzureAdTenantId: z.string(),
  AzureAdClientId: z.string(),
  AzureAdRedirectUri: z.string(),
  BackendUrl: z.string(),
  Stage: z.enum(['local', 'dev', 'test', 'prod']),
} satisfies { [K in keyof SapAdapterConfig]: z.ZodType<unknown, SapAdapterConfig[K]> });

export type BackendConfigJson = z.infer<typeof backendConfigJsonSchema>;
